import { render, staticRenderFns } from "./Badges.vue?vue&type=template&id=6785f17f&"
import script from "./Badges.vue?vue&type=script&lang=ts&"
export * from "./Badges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports